import { StoreOrderDetail } from '../../pages/StoreOrderDetail'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog'

interface StoreOrderDetailModalProps {
  open: boolean
  orderNumber: string | null
  onClose: () => void
  onOrderUpdated: () => void
}

export function StoreOrderDetailModal({
  open,
  orderNumber,
  onClose,
  onOrderUpdated,
}: StoreOrderDetailModalProps) {
  if (!orderNumber) return null

  return (
    <Dialog open={open} onOpenChange={(nextOpen) => !nextOpen && onClose()}>
      <DialogContent className="flex max-h-[92vh] flex-col gap-0 overflow-hidden p-0 sm:max-w-[calc(100vw-2rem)] lg:max-w-6xl">
        <DialogHeader className="border-b border-border px-5 py-4 pr-14">
          <DialogTitle>Detalle del pedido</DialogTitle>
          <DialogDescription className="break-all">
            Pedido {orderNumber}
          </DialogDescription>
        </DialogHeader>

        <div className="min-h-0 flex-1 overflow-y-auto p-4 sm:p-5">
          <StoreOrderDetail
            key={orderNumber}
            orderNumber={orderNumber}
            onOrderUpdated={onOrderUpdated}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
